import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import FleetsDashboard from './pages/FleetsDashboard';
import CrewManagementPage from './pages/CrewManagementPage';
import MonthlySchedulePage from './pages/MonthlySchedulePage';
import RuleSettingsPage from './pages/RuleSettingsPage';
import DutyCodesPage from './pages/DutyCodesPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/fleets"
            element={
              <ProtectedRoute>
                <FleetsDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fleet/:fleetId/crew"
            element={
              <ProtectedRoute>
                <CrewManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fleet/:fleetId/schedule"
            element={
              <ProtectedRoute>
                <MonthlySchedulePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fleet/:fleetId/rules"
            element={
              <ProtectedRoute>
                <RuleSettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fleet/:fleetId/codes"
            element={
              <ProtectedRoute>
                <DutyCodesPage />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/fleets" replace />} />
          <Route path="/dashboard" element={<Navigate to="/fleets" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;